/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { metaAdStructureFacebookDetails } from '../../axios/metaAdStructureFacebookDetails'
import type {
	MetaAdStructureFacebookDetailsError,
	MetaAdStructureFacebookDetailsPathParams,
	MetaAdStructureFacebookDetailsResponse,
} from '../../types/MetaAdStructureFacebookDetails'

export const metaAdStructureFacebookDetailsQueryKey = (
	metaAdCampaign: MetaAdStructureFacebookDetailsPathParams['metaAdCampaign'],
) => [{ url: '/meta/ad-campaign/:metaAdCampaign/facebook-details', params: { metaAdCampaign } }] as const

export type MetaAdStructureFacebookDetailsQueryKey = ReturnType<typeof metaAdStructureFacebookDetailsQueryKey>

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaAdStructureController.php MetaAdStructureController::facebookDetails */
export function metaAdStructureFacebookDetailsQueryOptions(
	metaAdCampaign: MetaAdStructureFacebookDetailsPathParams['metaAdCampaign'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		MetaAdStructureFacebookDetailsResponse,
		AxiosError<MetaAdStructureFacebookDetailsError>,
		MetaAdStructureFacebookDetailsResponse,
		MetaAdStructureFacebookDetailsQueryKey
	>({
		queryKey: metaAdStructureFacebookDetailsQueryKey(metaAdCampaign),
		queryFn: ({ signal }) =>
			metaAdStructureFacebookDetails(metaAdCampaign, { signal, ...config }).then(res => res.data),
		enabled: !!metaAdCampaign,
	})
}

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaAdStructureController.php MetaAdStructureController::facebookDetails */
export function useMetaAdStructureFacebookDetails<TSelectData = MetaAdStructureFacebookDetailsResponse>(
	metaAdCampaign: MetaAdStructureFacebookDetailsPathParams['metaAdCampaign'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					MetaAdStructureFacebookDetailsResponse,
					AxiosError<MetaAdStructureFacebookDetailsError>,
					TSelectData,
					MetaAdStructureFacebookDetailsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<MetaAdStructureFacebookDetailsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...metaAdStructureFacebookDetailsQueryOptions(metaAdCampaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/MetaAd/Http/Controllers/MetaAdStructureController.php MetaAdStructureController::facebookDetails */
export function useMetaAdStructureFacebookDetailsSuspense<TSelectData = MetaAdStructureFacebookDetailsResponse>(
	metaAdCampaign: MetaAdStructureFacebookDetailsPathParams['metaAdCampaign'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					MetaAdStructureFacebookDetailsResponse,
					AxiosError<MetaAdStructureFacebookDetailsError>,
					TSelectData,
					MetaAdStructureFacebookDetailsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<MetaAdStructureFacebookDetailsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...metaAdStructureFacebookDetailsQueryOptions(metaAdCampaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
